import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-legal-footer',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './legal-footer.component.html',
  styleUrls: ['../legal-pages.styles.scss'],
})
export class LegalFooterComponent {
  currentDate = new Date();
}
